/**
 * @file BaseService.ts
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { StorageKey } from "../components/login/utils/StorageKey";
import { container } from "../di/inversify.config";
import { Logger } from "../logger/Logger";
import { TYPES } from "../logger/Types";
import { ApiError } from "./models/ApiError";
var CryptoJS = require("crypto-js");  // eslint-disable-line

export abstract class BaseService {

    parseError(data: any): ApiError {
        const apiError = data as ApiError;

        return apiError;
    }

    protected logger: Logger = container.get<Logger>(TYPES.LoggerService);
    private secretKey = process.env.REACT_APP_SECRET_KEY;
    
    /**
     * Sets current loggedIn status
     * @param isLoggedIn boolean
     * @returns 
     */
    protected setIsLoggedIn = (isLoggedIn: boolean) => this.setValueFromSessionStorage(StorageKey.IsLoggedIn, isLoggedIn);

    /**
     * Sets values into sessionStorage
     * @param storageKey StorageKey
     * @param value string
     * @returns 
     */
    private setValueFromSessionStorage = (storageKey: StorageKey, value: any) =>{ 
        this.logger.warning(`setValueFromSessionStorage() - Encrypting....${value}`, BaseService.name);
        const encryptedText = CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey).toString();
        const decryptedText = CryptoJS.AES.decrypt(encryptedText, this.secretKey).toString(CryptoJS.enc.Utf8);
        this.logger.warning(`Decrypted - ${decryptedText}`, BaseService.name);

        this.logger.warning(`Encrypting ... encryptedText - ${storageKey} ${encryptedText}`, BaseService.name);
        window.localStorage.setItem(storageKey, encryptedText);
    };    
}